<template>

    <svg id="barcode" ></svg>

</template>

<script>
import JsBarcode from 'jsbarcode'
export default {
  name: 'jsBarcode',
  props: {
    user_id: null,
    background: null,
    lineColor: null
  },
  mounted () {
    JsBarcode('#barcode', this.user_id, {lineColor: this.lineColor, width: 3, height: 1, displayValue: false, margin: 0, background: this.background})
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/common/jsBarcode.vue